export class ConsentType {
  public static readonly TERMS = 'terms';
  public static readonly PRIVACY = 'privacy';
}

export class ConsentName {
  public static readonly ACT = 'act';
}

export class Consent {
  consentId: number;
  terms: string;
  privacy: string;
  version: number;
  name: string;
  accepted: boolean;
  purposes: Purpose[];
}

export class Purpose {
  purposeId: number;
  name: string;
  description: string;
  accepted: boolean;
  title: string;
  subTitle: string;
  icon: string;
}

export class UserSubmitConsentRequest {
  consentId: number;
  purposeIds: number[];
}

export class PurposeByUserIdResponse {
  consentId: number;
  purposes: Purpose[];
}

export class PurposeByUserIdRequest {
  consentId: number;
  purposeId: number;
}



// WEBPACK FOOTER //
// ./src/app/model/user/consent-model.ts